import { RootState } from '@/domain/store';

export const selectTags = (state: RootState) => {
  return state.tags.tags;
};
